import React from "react";
import noImage from "../assets/No_Image_Available.jpg";

const ProductInfoShare = ({ categoryName, brandName, productName, productPicture }) => {
    return (
        <div style={{
            display: 'flex',
            fontWeight: 'bold',
            border: '2px solid rgba(117, 117, 117, 0.4)',
            padding: '8px',
            background: 'var(--dataInfoColor)',
            borderRadius: '15px',
            justifyContent: 'center',
            alignItems: 'center',
            wordBreak: 'break-all'
        }}>
            <div style={{flex: '1', paddingRight: '10px'}}>
                <div><i className='bi bi-award'></i> {brandName}</div><hr className='m-0' />
                <div><i className='bi bi-box'></i> {productName}</div><hr className='m-0' />
                <div><i className='bi bi-tags'></i> {categoryName}</div><hr className='m-0' />
            </div>
            <div>
                <img
                    src={productPicture ? `data:image/jpeg;base64,${productPicture}` : noImage}
                    alt="Product Picture"
                    className="img-thumbnail"
                    style={{ width: "var(--productPictureWidth)", height: "var(--productPictureHeight)", objectFit: "cover" }}
                />
            </div>
        </div>
    );
}

export default ProductInfoShare;